<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-accreditation/"
    paramsName="demande_accreditation"
    :endpoint="endpoint"
    showPanier
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component :is="path" :sas="sas" @validation-changed="setState(path, $event)" :ref="path" :endpoint="endpoint">
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"
import InformationsGenerales from "@/components/Formulaires/DemandeAccreditation/InformationsGenerales.vue"
import Activites from "@/components/Formulaires/DemandeAccreditation/Activites.vue"
import Commentaires from "@/components/Formulaires/DemandeAccreditation/Commentaires.vue"
import Declarations from "@/components/Formulaires/DemandeAccreditation/Declarations.vue"
import Intervenants from "@/components/Formulaires/DemandeAccreditation/Intervenants.vue"
import CatalogueMaestro from "@/components/Formulaires/DemandeAccreditation/CatalogueMaestro.vue"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-accreditation",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "informations-generales", code: "titre-etape-1", state: "" },
        { path: "activites", code: "titre-etape-2", state: "" },
        { path: "intervenants", code: "titre-etape-3", state: "" },
        { path: "catalogue-maestro", code: "titre-etape-4", state: "" },
        { path: "declarations", code: "titre-etape-5", state: "" },
        { path: "commentaires", code: "titre-etape-6", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    InformationsGenerales,
    Activites,
    Intervenants,
    CatalogueMaestro,
    Commentaires,
    Declarations
  }
}
</script>

<style></style>
